export enum LocationGroupCode {
    SV="SV",
    GV="GV",
    SVF="SVF"
}